import React from 'react';
import { Collapse, CollapseProps } from 'antd';
import { CustomComponentProps } from '../types';

const { Panel } = Collapse;

export interface MyCollapsePanelProps {
  key: string;
  header: React.ReactNode;
  children: React.ReactNode;
  disabled?: boolean;
  collapsible?: 'header' | 'icon' | 'disabled';
  extra?: React.ReactNode;
  showArrow?: boolean;
}

export interface MyCollapseProps extends Omit<CollapseProps, 'onChange'> {
  panels?: MyCollapsePanelProps[];
  defaultActiveKey?: string | string[];
  activeKey?: string | string[];
  onChange?: (key: string | string[]) => void;
  accordion?: boolean;
  bordered?: boolean;
  ghost?: boolean;
  expandIconPosition?: 'start' | 'end';
}

/**
 * MyCollapse - Collapsible panels component
 * Perfect for organizing content in expandable sections
 */
const MyCollapse: React.FC<MyCollapseProps> = ({
  panels,
  children,
  defaultActiveKey,
  activeKey,
  onChange,
  accordion = false,
  bordered = true,
  ghost = false,
  expandIconPosition = 'start',
  ...rest
}) => {
  const handleChange = (key: string | string[]) => {
    if (onChange) {
      onChange(key);
    }
  };

  return (
    <Collapse
      defaultActiveKey={defaultActiveKey}
      activeKey={activeKey}
      onChange={handleChange}
      accordion={accordion}
      bordered={bordered}
      ghost={ghost}
      expandIconPosition={expandIconPosition}
      {...rest}
    >
      {panels
        ? panels.map((panel) => (
            <Panel
              key={panel.key}
              header={panel.header}
              disabled={panel.disabled}
              collapsible={panel.collapsible}
              extra={panel.extra}
              showArrow={panel.showArrow}
            >
              {panel.children}
            </Panel>
          ))
        : children}
    </Collapse>
  );
};

export default MyCollapse;
